module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_7_4.c9e485f3.jpeg";